module.exports = __webpack_public_path__ + "static/media/404-permalink.69b84a32.png";